/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SubmitFeedbackRequestBody,
  SubmitFeedbackRequestBody$Outbound,
  SubmitFeedbackRequestBody$outboundSchema,
} from "../components/submitfeedbackrequestbody.js";

export type SubmitFeedbackSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SubmitFeedbackSecurityOption2 = {
  chatSessionsTokenHeaderGramChatSession: string;
};

export type SubmitFeedbackSecurity = {
  option1?: SubmitFeedbackSecurityOption1 | undefined;
  option2?: SubmitFeedbackSecurityOption2 | undefined;
};

export type SubmitFeedbackRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Chat Sessions token header
   */
  gramChatSession?: string | undefined;
  submitFeedbackRequestBody: SubmitFeedbackRequestBody;
};

/** @internal */
export type SubmitFeedbackSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SubmitFeedbackSecurityOption1$outboundSchema: z.ZodMiniType<
  SubmitFeedbackSecurityOption1$Outbound,
  SubmitFeedbackSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function submitFeedbackSecurityOption1ToJSON(
  submitFeedbackSecurityOption1: SubmitFeedbackSecurityOption1,
): string {
  return JSON.stringify(
    SubmitFeedbackSecurityOption1$outboundSchema.parse(
      submitFeedbackSecurityOption1,
    ),
  );
}

/** @internal */
export type SubmitFeedbackSecurityOption2$Outbound = {
  "chat_sessions_token_header_Gram-Chat-Session": string;
};

/** @internal */
export const SubmitFeedbackSecurityOption2$outboundSchema: z.ZodMiniType<
  SubmitFeedbackSecurityOption2$Outbound,
  SubmitFeedbackSecurityOption2
> = z.pipe(
  z.object({
    chatSessionsTokenHeaderGramChatSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      chatSessionsTokenHeaderGramChatSession:
        "chat_sessions_token_header_Gram-Chat-Session",
    });
  }),
);

export function submitFeedbackSecurityOption2ToJSON(
  submitFeedbackSecurityOption2: SubmitFeedbackSecurityOption2,
): string {
  return JSON.stringify(
    SubmitFeedbackSecurityOption2$outboundSchema.parse(
      submitFeedbackSecurityOption2,
    ),
  );
}

/** @internal */
export type SubmitFeedbackSecurity$Outbound = {
  Option1?: SubmitFeedbackSecurityOption1$Outbound | undefined;
  Option2?: SubmitFeedbackSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SubmitFeedbackSecurity$outboundSchema: z.ZodMiniType<
  SubmitFeedbackSecurity$Outbound,
  SubmitFeedbackSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SubmitFeedbackSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SubmitFeedbackSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function submitFeedbackSecurityToJSON(
  submitFeedbackSecurity: SubmitFeedbackSecurity,
): string {
  return JSON.stringify(
    SubmitFeedbackSecurity$outboundSchema.parse(submitFeedbackSecurity),
  );
}

/** @internal */
export type SubmitFeedbackRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Chat-Session"?: string | undefined;
  SubmitFeedbackRequestBody: SubmitFeedbackRequestBody$Outbound;
};

/** @internal */
export const SubmitFeedbackRequest$outboundSchema: z.ZodMiniType<
  SubmitFeedbackRequest$Outbound,
  SubmitFeedbackRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramChatSession: z.optional(z.string()),
    submitFeedbackRequestBody: SubmitFeedbackRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      gramChatSession: "Gram-Chat-Session",
      submitFeedbackRequestBody: "SubmitFeedbackRequestBody",
    });
  }),
);

export function submitFeedbackRequestToJSON(
  submitFeedbackRequest: SubmitFeedbackRequest,
): string {
  return JSON.stringify(
    SubmitFeedbackRequest$outboundSchema.parse(submitFeedbackRequest),
  );
}
